import React, { useEffect, useState } from "react";

const DateTime = () => {
  const [dateTime, setDateTime] = useState("");

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const formatted = now.toLocaleString("en-IN", {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      setDateTime(formatted);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div style={styles.container}>
      <p style={styles.text}>{dateTime}</p>
    </div>
  );
};

const styles = {
  container: {
    position: "absolute",
    top: "3px",
    left: "10px",   // stays at right side like weather
    background: "rgba(0,0,0,0.6)",
    color: "white",
    padding: "6px 10px",
    borderRadius: "8px",
    fontSize: "12px",
    width: "auto",
    textAlign: "center",
    zIndex: 1000,
  },
  text: {
    margin: 0,
  },
};

export default DateTime;
